import { EventsService } from "@app/services/events.service"
import { ActivatedRoute, Router } from "@angular/router"
import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ConfigDefinitions } from "@app/definitions/types"
import { ValidatorService } from "@app/services/validator.service"
import { LangService } from "@app/services/lang.service"

import { ApiService } from "@app/services/api.service"
import { Configcliniq } from "@app/definitions/types"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { MenuService } from "@app/services/menu.service"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { ReportsComponent } from "@app/reports/reports.component"
import { GraphsDataComponent } from "@app/graphs-data/graphs-data.component"
import { TaxesReportComponent } from "@app/taxes-report/taxes-report.component"
import { ProfitlossComponent } from "@app/profitloss/profitloss.component"
import { SubUserPatientsComponent } from "@app/sub-user-patients/sub-user-patients.component"
import { SubUserPaymentsComponent } from "@app/sub-user-payments/sub-user-payments.component"
import { FollowupsForSupervisorListComponent } from "@app/followups-for-supervisor-list/followups-for-supervisor-list.component"

@Component({
	selector: "app-reports-dashboard",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenTableComponent,
		ReportsComponent,
		GraphsDataComponent,
		TaxesReportComponent,
		ProfitlossComponent,
		SubUserPatientsComponent,
		SubUserPaymentsComponent,
		FollowupsForSupervisorListComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./reports-dashboard.component.html",
})
export class ReportsDashboardComponent implements OnInit {
	curItem: any
	showMenu: boolean = false //show the menu or hide (relevant only in mobile display)

	sideItems: any[] = []

	constructor(
		public lang: LangService,
		public validator: ValidatorService,
		private route: ActivatedRoute,
		public eventsService: EventsService,
		public permsService: PermsService,
		public router: Router,
		private store: StoreService,
		public menuService: MenuService
	) {}

	async ngOnInit() {
		this.sideItems = this.menuService.menu
			.find((it) => it?.id == "financial")
			.children.filter((it) => !it.hidden && !it.hiddenCc)
		this.sideItems = [
			{ intro: true, icon: "zzz", lang: "zzzz" },
			...this.sideItems,
		]
		this.curItem = this.sideItems[0]
		this.showMenu = !this.eventsService.isMobile //reset to false if mobile

		this.route.queryParams.subscribe((params) => {
			if (params["showMenu"]) {
				if (this.eventsService.isMobile) {
					this.showMenu = true
				}
			}
		})

		this.eventsService.isMobileSubj.subscribe(() => {
			//when isMobile changes, make sure to reset again (mobile is false)
			this.showMenu = !this.eventsService.isMobile
		})
	}

	sideMenuClick(item: any) {
		//on clicking any side menu item, if mobile - closes the menu
		window.scroll(0, 0)
		if (this.eventsService.isMobile) {
			this.showMenu = false
		}
		this.curItem = null
		setTimeout(() => {
			this.curItem = item
		})
	}
}
